// extracted by mini-css-extract-plugin
export default {"root":"EWayBillCreatePage_root__vOF8h","body":"EWayBillCreatePage_body__-rNMt","items-details-container":"EWayBillCreatePage_items-details-container__BEF0B"};